(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sca-cart-controls"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('sca-catalog-cart')) return;
  const roots = new Set();
  let busy = false;
  let revision = 0;
  let lastCart;
  let timer;
  const rootUrl = () => window.Shopify?.routes?.root || '/';
  async function request(path, payload) {
    const options = { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } };
    if (payload) {
      options.method = 'POST';
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(payload);
    }
    const response = await window.fetch(rootUrl() + path, options);
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Le panier n’a pas pu être mis à jour. Merci de réessayer.');
    return data;
  }
  function linesFor(cart, root) {
    return cart.items.filter(item => String(item.variant_id) === root.dataset.variantId
      && !item.selling_plan_allocation
      && Object.keys(item.properties || {}).length === 0
      && !item.parent_relationship);
  }
  function paint(cart) {
    lastCart = cart;
    roots.forEach(root => {
      const add = root.querySelector('[data-scap-add]');
      const stepper = root.querySelector('[data-scap-quantity]');
      const value = root.querySelector('[data-scap-value]');
      if (!add || !stepper || !value) return;
      const quantity = linesFor(cart, root).reduce((total, item) => total + item.quantity, 0);
      const focused = root.contains(document.activeElement);
      const wasAdded = add.hidden;
      add.hidden = quantity > 0;
      stepper.hidden = quantity === 0;
      value.textContent = String(quantity);
      if (focused && wasAdded !== add.hidden) {
        root.scaFocusTarget = quantity ? root.querySelector('[data-scap-delta="1"]') : add;
        if (!busy) { root.scaFocusTarget.focus({ preventScroll: true }); root.scaFocusTarget = null; }
      }
    });
    if (!window.scentalyaCartCounter) {
      document.querySelectorAll('.cart-count').forEach(counter => {
        counter.textContent = String(cart.item_count);
        counter.hidden = cart.item_count === 0;
        counter.style.setProperty('display', cart.item_count ? 'flex' : 'none', 'important');
      });
    }
  }
  function lock(value) {
    roots.forEach(root => {
      root.setAttribute('aria-busy', String(value));
      root.querySelectorAll('button').forEach(button => { button.disabled = value; });
      if (!value && root.scaFocusTarget) {
        root.scaFocusTarget.focus({ preventScroll: true });
        root.scaFocusTarget = null;
      }
    });
  }
  async function refresh() {
    if (busy) return;
    const currentRevision = ++revision;
    try {
      const cart = await request('cart.js');
      if (!busy && revision === currentRevision) paint(cart);
    } catch (error) { console.warn('Scentalya : synchronisation du catalogue indisponible.', error); }
  }
  function schedule() { revision += 1; clearTimeout(timer); timer = setTimeout(refresh, 100); }
  async function change(root, delta) {
    if (busy) return;
    busy = true;
    revision += 1;
    lock(true);
    const errorBox = root.querySelector('.scap-cart-error');
    errorBox.hidden = true;
    errorBox.textContent = '';
    try {
      if (delta > 0) {
        await request('cart/add.js', { items: [{ id: Number(root.dataset.variantId), quantity: 1 }] });
        paint(await request('cart.js'));
      } else {
        const cart = await request('cart.js');
        const lines = linesFor(cart, root);
        const line = lines[lines.length - 1];
        paint(line ? await request('cart/change.js', { id: line.key, quantity: Math.max(0, line.quantity - 1) }) : cart);
      }
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: lastCart, source: 'sca-catalog-cart' } }));
    } catch (error) {
      errorBox.textContent = error.message || 'Impossible de modifier le panier. Merci de réessayer.';
      errorBox.hidden = false;
      try { paint(await request('cart.js')); } catch (_) {}
      window.scentalyaCartCounter?.refresh();
    } finally { busy = false; lock(false); schedule(); }
  }
  class CatalogCart extends HTMLElement {
    connectedCallback() {
      roots.add(this);
      if (!this.scaAbort) {
        this.scaAbort = new AbortController();
        this.addEventListener('submit', event => {
          if (!event.target.matches('.scap-product-form')) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          change(this, 1);
        }, { capture: true, signal: this.scaAbort.signal });
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-scap-delta]');
          if (!button || !this.contains(button)) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          change(this, Number(button.dataset.scapDelta));
        }, { capture: true, signal: this.scaAbort.signal });
      }
      if (lastCart) paint(lastCart);
      lock(busy);
      schedule();
    }
    disconnectedCallback() { roots.delete(this); this.scaAbort?.abort(); this.scaAbort = null; }
  }
  customElements.define('sca-catalog-cart', CatalogCart);
  ['cart:updated', 'cart:refresh', 'cart:change', 'shopify:section:load'].forEach(name => document.addEventListener(name, schedule));
  ['pageshow', 'focus', 'online'].forEach(name => window.addEventListener(name, schedule));
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') schedule(); });
})();
  } catch(e) { console.error(e); }
})();

})();
